// extracted by mini-css-extract-plugin
export default {"main":"page_main__9qPCL"};